var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.wide ? 'rounded-b-wide' : 'rounded-b-tight',
    {
      'border-hover-active': _vm.hoverHighlight,
      'cursor-pointer': !!_vm.to
    }
  ],on:{"click":_vm.handleClick}},[_c('div',{staticClass:"flex items-center shadow-lg",class:[
      { 'flex-col': _vm.center },
      _vm.bgGray ? 'bg-gray border-t-2 border-r-2 border-l-2 border-hover border-theme1' : 'bg-theme1',
      _vm.wide ? 'rounded-t-wide p-8 md:p-16' : 'rounded-t-tight p-8',
      !_vm.content && (_vm.wide ? 'rounded-wide' : 'rounded-tight')
    ]},[_c('CoreIcon',{staticClass:"h-16",attrs:{"icon":_vm.icon,"black":_vm.bgGray}}),_c('h2',{staticClass:"text-2 md:text-1 leading-none",class:[
        { 'text-white': !_vm.bgGray },
        _vm.center ? 'mt-8' : 'ml-8'
      ],domProps:{"textContent":_vm._s(_vm.title)}})],1),(_vm.content)?_c('div',{staticClass:"bg-gray border-b-2 border-r-2 border-l-2 border-hover border-theme1 shadow-lg flex flex-col flex-grow",class:[_vm.wide ? 'rounded-b-wide p-8 md:p-16' : 'rounded-b-tight p-8', { 'pt-0': _vm.bgGray}]},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }